import { push } from 'react-router-redux';
import { some } from 'lodash';
import { fetchAuthSession, signOut } from 'aws-amplify/auth';

import { setAppIsReady } from './readyApp';
import { AuthApi } from '../../services/auth-service';
import { getErrorMessage, hasRole } from '../../constants/utils';
import config from '../../constants/config';
import { clearError, handleError } from '../../services/error-handler';
import { clearErrorHandler, clearSettings, initCart } from '../actions';
import { setUserRetailers } from './user/user-retailer';
import { ENABLE_LOADING } from '../type/cognito/cognito-login';

const authApi = new AuthApi();

export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGOUT = 'LOGOUT';
export const STORE_NEW_CHECKED_TIME = 'STORE_NEW_CHECKED_TIME';

const { LOGIN_PAGE, DASHBOARD, CONFIGURATION_MANAGEMENT } = config.ROUTE_URLS;
const { COGNITO_ENABLED } = config;
const loginSuccess = (data) => {
    return (dispatch, getState) => {
        const wasAuthenticated = !!getState().auth.token;

        dispatch({
            type: LOGIN_SUCCESS,
            token: data.token,
            info: data.userInfo,
        });

        if (some(data.userInfo.roles, (role) => role === 'RE_RETAILER')) {
            dispatch(setUserRetailers(data.userInfo?.user_id));
        } else if (
            // Only redirect on fresh login. During refresh Cognito may return userInfo
            // before Redux restores auth, so this guard prevents unwanted #/dashboard redirects.
            !wasAuthenticated &&
            some(data.userInfo.roles, (role) => role === 'RE_ADMIN')
        ) {
            if (hasRole(data.userInfo.authorities, 'ROLE_RE_DASHBOARD_PAGE')) {
                dispatch(push(`#${DASHBOARD}`));
            } else {
                dispatch(push(`#${CONFIGURATION_MANAGEMENT}`));
            }
        }
    };
};

const loginError = (errors) => {
    return {
        type: LOGIN_ERROR,
        errors: getErrorMessage(errors),
    };
};

export const login = (args) => {
    return async (dispatch) => {
        dispatch({ type: LOGIN });
        dispatch(clearError());
        dispatch(clearErrorHandler());
        try {
            const token = await authApi.authenticate(args);
            const userInfo = await AuthApi.getUserInfo(token);

            return dispatch(
                loginSuccess({
                    token,
                    userInfo,
                }),
            );
        } catch (err) {
            dispatch({
                type: ENABLE_LOADING,
                payload: false,
            });
            return dispatch(loginError(err));
        }
    };
};

export const cognitoLogin = () => {
    return async (dispatch) => {
        dispatch(clearError());
        try {
            const session = await fetchAuthSession();
            const token = session?.tokens?.accessToken;
            dispatch(
                login({
                    code: `${token}`,
                    grant_type: config.CUSTOM_GRANT_TYPE.COGNITO,
                }),
            );
        } catch (err) {
            return dispatch(handleError(err));
        }
    };
};

export const logout = () => {
    return async (dispatch) => {
        dispatch(setAppIsReady(true));
        dispatch({ type: LOGOUT });
        if (!COGNITO_ENABLED) {
            dispatch(push(`#${LOGIN_PAGE}`));
        }
        dispatch(clearSettings());
        dispatch(initCart());
        dispatch(clearError());
        if (COGNITO_ENABLED) {
            await signOut();
        }
    };
};

export const saveNewUserValidTime = () => {
    return (dispatch) => {
        dispatch({ type: STORE_NEW_CHECKED_TIME });
    };
};
